import { PaginatorDesignTokens } from "@primeuix/themes/types/paginator";

export const paginator: PaginatorDesignTokens = {
    root: {
        padding: "18px 22px",
    },
    css: ({ dt }) => {
        const defaultPaginator = `
            .p-paginator {
                justify-content: space-between;
                position: sticky;
                bottom: 0;
                border-bottom: 1px solid ${dt("shade-200")};

                .p-paginator-current {
                    justify-content: start;
                }

                .p-paginator-pages {
                    display: flex;
                    justify-content: end;
                }

                .p-paginator-content-end {
                    display: flex;
                    justify-content: end;
                    margin-inline-start: initial;
                }
            }

            .p-paginator-page {
                background-color: transparent;
                font-weight: bold;
            }

            .p-paginator-prev,
            .p-paginator-next {
                display: none;
            }
        `;

        return defaultPaginator;
    },
};
